import { APP_INITIALIZER, ErrorHandler, Provider } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { initSentry } from './sentry.config';

export const provideSentry = (): Provider[] => [
  {
    provide: ErrorHandler,
    useFactory: () => Sentry.createErrorHandler({ showDialog: false })
  },
  {
    provide: Sentry.TraceService,
    deps: [Router]
  },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => initSentry(),
    deps: [Sentry.TraceService],
    multi: true
  }
];
